<template>
  <div>
    <van-nav-bar class="backBox" :title="h5Config.textCfg.title" />
    <div class="content_box">
      <div class="main">
        <div v-if="!showError">
          <van-loading size="24px" vertical>加载中...</van-loading>
        </div>
        <div v-else>
          <div class="signOk">
            <div class="img">
              <img src="../assets/imgs/resetQRCode.jpg" alt="" />
            </div>
            <span class="title">{{showErrorText}}!</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from '../api/api'
import * as common from '../api/common'
import { Toast, Dialog } from 'vant'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      showError: false,
      showErrorText: ''
    }
  },
  mounted () {
    const dataParameter = this.$route.query.data
    console.log('dataParameter', dataParameter)
    if (dataParameter) {
      console.log(typeof JSON.parse(atob(dataParameter)))
      console.log(JSON.parse(atob(dataParameter)))

      this.vip_login(JSON.parse(atob(dataParameter)))
    } else {
      console.log('访问失败')
      Toast.fail('无效链接，请检查或联系管理员')
    }
  },
  computed: {
    ...mapGetters([
      'h5Config'
    ])
  },
  methods: {
    vip_login (para) {
      api
        .axiosRequest(api.urlList.vip_login, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {
            if (res.user_info) {
              api.setAccessToken(res.access_token)

              this.$store.commit('USERINFO', JSON.stringify(res.user_info))
              api.setUser(JSON.stringify(res.user_info))

              this.$router.replace('/order')
              this.$nextTick(() => {
                Toast('欢迎' + para.account)
              })
            }
          } else {
            this.showError = true
            this.showErrorText = res.msg
            Dialog.alert({
              title: '访问失败',
              message: res.msg,
              confirmButtonText: '关闭'
            }).then(() => {
            })
          }
        })
        .catch((e) => console.log('Error:', e))
    }

  }
}
</script>
<style scoped>

.signOk {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 2rem;
}
.img {
  width: 13.4375rem;
  height: 11.5625rem;
}
.img img {
  width: 100%;
  height: 100%;
}
.title {
  margin-top: 2rem;
}
</style>
